function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.516 10.889h-2.254V3H9.008v7.889H6.754V3H4.5v7.889a4.492 4.492 0 0 0 4.226 4.474V25.54h2.817V15.363a4.492 4.492 0 0 0 4.226-4.474V3h-2.253zm5.635-3.381v9.016h2.817v9.016h2.817V3c-3.11 0-5.634 2.524-5.634 4.508z",
  transform: "translate(9.5 11.96)"
}));

var SvgIconTopCities = function SvgIconTopCities(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTopCities, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_top_cities.ab5c24bf.svg";
export { ForwardRef as ReactComponent };